import React from 'react'
import UserConfirmationModal from './UserConfirmationModal'
import PropTypes from 'prop-types'
import EnterPassword from './pages/EnterPassword'
import SetPassword from './pages/SetPassword'
import EnterCode from './pages/EnterCode'
import SsoSignIn from './pages/SsoSignIn'

class LinkAuthedUserConfirmationModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = this.initialState()
  }

  initialState = () => (
    {
      confirmed: false,
      isRevealed: false
    }
  )

  handleModalClose = (close) => {
    if (!this.state.confirmed) {
      this.setState(this.initialState())
      close()
    }
  }

  initialPage = () => {
    if (this.props.ssoSignInUrl && !this.props.userHasPassword) {
      return 'SsoSignIn'
    }

    return this.props.userHasPassword ? 'EnterPassword' : 'EnterCode'
  }

  renderContent = ({ currentPage, isRevealed, advanceToPage, close }) => {
    switch (currentPage) {
      case 'SsoSignIn':
        return (
          <SsoSignIn
            ssoSignInUrl={this.props.ssoSignInUrl}
            supportEmail={this.props.supportEmail}
          />
        )
      case 'EnterPassword':
        return (
          <EnterPassword
            email={this.props.email}
            ssoSignInUrl={this.props.ssoSignInUrl}
            onSuccess={() => {
              if (this.props.requestedUrl) {
                window.location.href = this.props.requestedUrl
              } else {
                close()
              }
            }}
            onResetPassword={() => advanceToPage('EnterCode')}
          />
        )
      case 'EnterCode':
        return (
          <EnterCode
            email={this.props.email}
            readyToSendInitialCode={isRevealed}
            supportEmail={this.props.supportEmail}
            onSuccess={() => {
              this.setState({ confirmed: true })
              advanceToPage('SetPassword')
            }}
          />
        )
      case 'SetPassword':
        return (
          <SetPassword
            email={this.props.email}
            supportEmail={this.props.supportEmail}
            onSuccess={() => {
              if (this.props.requestedUrl) {
                window.location.href = this.props.requestedUrl
              } else {
                close()
              }
            }}
          />
        )
    }
  }

  render () {
    return (
      <UserConfirmationModal
        render={this.renderContent}
        initialPage={this.initialPage()}
        modalId={this.props.modalId}
        onModalClose={this.handleModalClose}
      />
    )
  }
}

LinkAuthedUserConfirmationModal.propTypes = {
  email: PropTypes.string.isRequired,
  userHasPassword: PropTypes.bool,
  requestedUrl: PropTypes.string,
  ssoSignInUrl: PropTypes.string,
  supportEmail: PropTypes.string.isRequired,
  modalId: PropTypes.string.isRequired
}

LinkAuthedUserConfirmationModal.defaultProps = {
  userHasPassword: false,
  requestedUrl: null,
  ssoSignInUrl: null
}

export default LinkAuthedUserConfirmationModal
